import { useField } from 'formik';
import React from 'react';
import { Form, Label, Select } from 'semantic-ui-react';

interface Props {
  placeholder: string;
  name: string;
  options: any;
  label?: string;
  disabled?: boolean;
  // onChange?: (e: any, { value }: any) => void;
}

const MySelectInput = (props: Props) => {
  const [field, meta, helpers] = useField(props.name);
  return (
    <Form.Field error={meta.touched && !!meta.error} inline>
      {props.label && <label style={{ width: '20%' }}>{props.label}</label>}
      <Select
        disabled={props.disabled}
        style={{ width: props.label ? '75%' : '100%' }}
        clearable
        options={props.options}
        value={field.value || null}
        onChange={(e, d) => helpers.setValue(d.value)}
        onBlur={() => helpers.setTouched(true)}
        placeholder={props.placeholder}
      />
      {meta.touched && meta.error ? (
        <Label basic color="red">
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
};
export default MySelectInput;
